/**
 * Non-legal market force entry (rating, insurance, fleet, media). Plan §26.11.
 *
 * Kaiyang Lesson §25.7 / ADR-0002 red line #3: market_force / ecosystem_signal
 * entries NEVER count toward Legal Readiness. Two structural defenses:
 *   1. `obligationKind` is restricted to a 2-value enum that excludes hard_law.
 *   2. `nonLegalNotice` is a locked string literal that downstream renderers
 *      use to visibly label the entry.
 */

import { z } from "zod";

export const MarketForceEntrySchema = z.object({
  entryId: z.string().min(1),
  obligationKind: z.enum(["market_force", "ecosystem_signal"]),
  jurisdictionCode: z.string().min(1),
  /**
   * Free-form domain string; semantic anchoring lives in MarketForceSource
   * below. Avoids cross-import from `primitives.ts` so this file stays leaf.
   */
  regulatoryDomain: z.string().min(1),
  source: z.enum([
    "ncap",
    "insurance",
    "fleet_buyer",
    "media",
    "rating_agency",
    "platform",
    "ecosystem_partner",
    "other",
  ]),
  description: z.string(),
  legalReferenceIds: z.array(z.string()).optional(),
  detectedAt: z.string(),
  validUntil: z.string().optional(),
  nonLegalNotice: z.literal("Excluded from Legal Readiness"),
});

export type MarketForceEntry = z.infer<typeof MarketForceEntrySchema>;
